import { h, Component, Host, Element, Prop } from "@stencil/core";
// import pfx from "../../../utils/style-class-prefix-helper";

@Component({
  tag: "eon-ui-carousel-item",
  styleUrl: "carousel-item.scss",
  shadow: true
})
export class CarouselItem {
  @Element() hostElement: HTMLEonUiCarouselItemElement;

  /**
   * Specifies the label to use for accessibility.
   */
  @Prop() ariaLabel: string;

  render() {
    return (
      <Host aria-label={!!this.ariaLabel && this.ariaLabel}>
        <slot />
      </Host>
    );
  }
}
